<template>
  <div>
    <step :navItems="navItems" :step="0" :index="0" v-on:back="() => { this.$router.push('/group-mgr') }" v-on:finish="() => { this.$router.push('/group-mgr') }">
      <template slot="header">
        <h3>{{$t('upload_excel')}}</h3>
        <a href="./static/files/老師端學生匯入格式.xlsx" download>{{$t('download_demo')}}</a>
      </template>

      <template slot="body">
        <div class="row mt-3">
          <div class="col-8 offset-2">
            <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" v-show="false" v-if="uploadReady" />

            <ul class="list-group list-group-flush">
              <li class="list-group-item border text-left mb-3"
                style="line-height: 150%; cursor: pointer;"
                @click="$refs.file.click()"
                v-if="file === null">
                <div class="float-left">
                  {{$t('upload_tips')}}<br />
                  {{$t('upload_rules')}}
                </div>
              </li>

              <li class="list-group-item border text-left mb-3"
                style="line-height: 150%;"
                v-else>
                <div class="float-left">
                  {{ file.name }}<br />{{ Math.round(file.size / 1024 / 1024) }} MB
                </div>

                <div class="float-right">
                  <span class="btn btn-xs p-0" @click="upload()">
                    <img src="~../../assets/image/icon/upload_on.png" v-if="false" />
                    <img src="~../../assets/image/icon/upload_off.png" v-else />
                  </span>
                </div>
              </li>

              <li class="list-group-item text-left mb-3 border-0 clearfix pt-4"  v-if="progress > -1">
                <div class="float-left">{{$t('upload_progress')}}：</div>
                <div class="progress mt-2" style="height: 0.2rem;">
                  <div class="progress-bar progress-bar-danger progress-bar-striped active"
                    role="progressbar"
                    :aria-valuenow="progress"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    v-bind:style="{ width: progress + '%', 'border-width': '1px' }">
                    <span class="sr-only">{{ progress }}% {{$t('_finish') }}</span>
                  </div>
                </div>
                <icon-button name="cancelUpload" style="position: absolute; top: 0; right: 0;" @click.native="cancelUpload()" />
              </li>
            </ul>
          </div>
        </div>
      </template>
    </step>
  </div>
</template>

<script>
import Step from './Step'
import api from '../../store/api'
import axios from 'axios'
import IconButton from './IconButton'

export default {

  name: 'TeachingGroupAddStudentByExcel',

  components: {
    Step,
    IconButton
  },

  data () {
    return {
      groupId: null,
      navItems: [this.$t('add_students_in_batches')],
      file: null,
      progress: -1,
      source: null,
      uploadReady: true
    }
  },

  async mounted () {
    this.groupId = this.$route.params.groupId
  },

  methods: {
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
      console.log(this.file)
    },

    async upload () {
      const CancelToken = axios.CancelToken
      this.source = CancelToken.source()

      let formData = new window.FormData()
      formData.append('file', this.file)

      this.progress = 0
      const { data } = await api.post('/GroupMgr/TeachingGroups/' + this.groupId + '/Students/Import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        cancelToken: this.source.token,
        onUploadProgress: this.uploadProgress
      })

      if (data.status === 'OK') {
        this.file = null
        this.progress = -1
        this.uploadReady = false
        this.$nextTick(() => {
          this.uploadReady = true
        })
        console.log('complete', data.data)
      }
    },

    cancelUpload () {
      this.source.cancel('Operation canceled by the user.')
      console.log('canceled')
      this.progress = -1
    },

    uploadProgress (oEvent) {
      let self = this

      if (oEvent.lengthComputable) {
        let percentComplete = Math.round(oEvent.loaded * 100 / oEvent.total)
        self.progress = percentComplete
      } else {
        // Unable to compute progress information since the total size is unknown
        self.progress = -1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// TeachingGroupAddStudentByExcel.vue?d6e4f8de